import script from "./JobLogModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./JobLogModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QTimeline from 'quasar/src/components/timeline/QTimeline.js';
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QTimelineEntry from 'quasar/src/components/timeline/QTimelineEntry.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTimeline,QVirtualScroll,QTimelineEntry,QExpansionItem});
